import { HttpErrorResponse } from '@angular/common/http';
import { EntityState } from '@ngrx/entity';
import type {
    UserNotification,
    UserNotificationsFilter,
} from '../../actions/user-notifications.actions';

export interface IUserNotificationsFeatureState extends EntityState<UserNotification> {
    loading: boolean;
    error: HttpErrorResponse | null;
    offset: number;
    limit: number;
    filter: UserNotificationsFilter;
    unreadCount: number;
}
